<mat-dialog-content class="modal-header"><h2 mat-dialog-title>HISTORIAL DE COMENTARIOS</h2></mat-dialog-content>

<mat-dialog-content class="modal-body">
    <div class="content">
        <app-log-table [listaLogModel]="data"></app-log-table>    
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="modal-actions">
    <button type="button" class="btn btn-naranja2" mat-button mat-dialog-close><mat-icon>exit_to_app</mat-icon> Salir</button>
</mat-dialog-actions>
